
import { Typography } from '@mui/material';

import Header from '../../../../components/Header';
import { headerLink } from '../../../../navigation/function';
import { accountNavigation } from '../../../../navigation/account';
import Preferences from '../../../../components/Users/Preferences';

export default function CommunicationPreferences() {
    const accountLink = headerLink(accountNavigation.account);
    const preferencesLink = headerLink(accountNavigation.communicationPreferences, true);

    return (
        <div>
            <Header>
                <div>
                    Members | {accountLink} | {preferencesLink}
                </div>
            </Header>
            <Typography variant='h3' color='black.main' className='mt-4'>
                Communication Preferences
            </Typography>
            <Typography variant='body1' color='primary.900'>
                Maintaining a good relationship with you while protecting and respecting your privacy is important to us. Please let us know what type of content we may send by filling in the boxes for approved communications.
            </Typography>
            <Preferences />
        </div>
    );
}
